import DeleteUser from "@/v2/api/users/Delete";
import DeleteButton from "../general/Delete";

export default function UserDeleteButton({
    id,
    isInside = false,
}: {
    id: string;
    isInside?: boolean;
}) {
    return (
        <DeleteButton
            id={id}
            queryKey={["users"]}
            deleteFn={DeleteUser}
            title="Delete Member"
            description="Are you sure you want to delete this user member? This action cannot be undone. Click delete to confirm."
            successTitle="User Deleted Successfully"
            isInside={isInside}
        />
    );
}
